{
  "titles": {
    "fundingContractCashflow": "Spaarders kasstroom",
    "fundingContractInterest": "Spaarders rentekosten",
    "activeFunderRatio": "Actieve spaarders verhouding",
    "fundingIn": "Nieuwe contracten",
    "fundingOut": "Aflopende contracten",
    "fundingContractVariantRatio": "Variant verhouding",
    "numberOfFundingContracts": "Aantal contracten",
    "fundingContractDeviations": "Afwijkingen",
    "averageFunding": "Gemiddelde inleg",
    "partnerFee": "Partner kosten",
    "cashflowPartner": "Kasstroom partner",
    "menu": "Rapportages",
    "reports": "Rapportages",
    "creditFacility": "Rapportage rekening courant"
  },
  "fields": {
    "labels": {
      "reportType": "Rapportage",
      "startDate": "Startdatum",
      "endDate": "Einddatum",
      "granularity": "Periode"
    }
  },
  "options": {
    "granularity": {
      "yearly": "Per jaar",
      "weekly": "Per week",
      "monthly": "Per maand"
    }
  },
  "table": {
    "headers": {
      "generatedAt": "Rapport gegenereerd op {date}"
    },
    "labels": {
      "FinancingCostsCategory": "Financieringskosten",
      "TotalAmount": "Leningen",
      "AverageDurationInDays": "Looptijd",
      "CostRate30Days": "% kosten 30 dagen",
      "LoanCount": "Aantal leningen",
      "FinanceReceiverCount": "Aantal klanten",
      "RevenueCategory": "Omzet DebitRoom",
      "RevenueFinancingCosts": "Omzet Financieringskosten",
      "RevenuePenalties": "Omzet Achterstallige rente",
      "RevenueAdministrationCosts": "Omzet Administratiekosten",
      "RevenueTreatmentFee": "Omzet Behandelkosten",
      "OpenLoansCategory": "Openstaande leningen",
      "TotalOpenAmount": "Openstaand bedrag (op einddatum)",
      "OpenLoanCount": "Aantal leningen",
      "OpenFinanceReceiverCount": "Aantal klanten",
      "LoanAverageAmount": "Gemiddeld bedrag per lening",
      "LoanAverageOpenAmount": "Gemiddeld bedrag per lening",
      "FinanceReceiverAverageAmount": "Gemiddeld bedrag per klant",
      "FinanceReceiverAverageOpenAmount": "Gemiddeld bedrag per klant"
    }
  },
  "messages": {
    "noDataForSelectedPeriod": "Er is geen data beschikbaar voor de geselecteerde periode."
  },
  "actions": {
    "generateReport": "Rapportage genereren",
    "exportToExcel": "Exporteren naar Excel"
  },
  "fundingContractCashflow": {
    "field": {
      "totalAmount": "Totale inleg",
      "newContracts": "Nieuwe contracten",
      "endedContracts": "Afgelopen contracten",
      "expectedEndedContracts": "Toekomstige aflopende contracten",
      "expectedStartingContracts": "Toekomstige startende contracten",
      "renewedContracts": "Verlengde contracten",
      "totalAmountDelta": "Verandering",
      "numberOfFundingContracts": "Aantal contracten"
    }
  },
  "activeFunderRatio": {
    "field": {
      "activeFunders": "Actieve spaarders",
      "inactiveFunders": "Inactieve spaarders"
    }
  },
  "fundingContractInterest": {
    "field": {
      "interestAmount": "Rente kosten",
      "expectedInterestAmount": "Verwachte rente kosten"
    }
  },
  "fundingContractVariantRatioPie": {
    "variants": {
      "protectedAll": "Beschermd",
      "plusProtected": "Plus (beschermd)",
      "plusNotProtected": "Plus (niet beschermd)"
    }
  },
  "fundingContractVariantRatio": {
    "variants": {
      "protectedAll": "Beschermd",
      "plusProtected": "Plus (beschermd)",
      "plusNotProtected": "Plus (niet beschermd)",
      "plusContracts": "Plus contracten",
      "protectedContracts": "Beschermde contracten"
    }
  },
  "funderCountPie": {
    "fields": {
      "current": "Op dit moment",
      "previousMonth": "Vorige maand"
    },
    "labels": {
      "active": "Actief",
      "inactive": "Inactief"
    }
  },
  "fundingContractDeviations": {
    "fields": {
      "labels": {
        "referenceNumber": "Contractnummer",
        "amount": "Inleg",
        "durationInMonths": "Looptijd",
        "interestRate": "Rente",
        "deviationProperty": "Afwijking",
        "requestedValue": "Aangevraagde waarde",
        "approvedValue": "Goedgekeurde waarde",
        "originalValue": "Originele waarde",
        "requestExplanation": "Aangevraagde toelichting",
        "approvedExplanation": "Goedgekeurde toelichting",
        "originalInterestCost": "Originele rentekosten",
        "deviatedInterestCost": "Goedgekeurde rentekosten"
      }
    }
  },
  "averageAmount": {
    "fields": {
      "averageAmountPerContract": "Per contract",
      "averageAmountPerFunder": "Per spaarder",
      "averageAmountPerPartner": "Per partner"
    }
  },
  "fundingIn": {
    "fields": {
      "labels": {
        "current": "Momenteel",
        "expected": "Verwachting"
      },
      "totalAmount": "Totale inleg",
      "newContracts": "Nieuwe contracten",
      "newContractsAmount": "Nieuwe contracten inleg",
      "renewedContracts": "Verlengde contracten",
      "renewedContractsAmount": "Verlengde contracten inleg",
      "expectedNewContracts": "Toekomstige nieuwe contracten",
      "expectedNewContractsAmount": "Toekomstige nieuwe contracten inleg",
      "expectedRenewedContracts": "Toekomstige verlengde contracten",
      "expectedRenewedContractsAmount": "Toekomstige verlengde contracten inleg"
    }
  },
  "fundingOut": {
    "fields": {
      "labels": {
        "current": "Momenteel",
        "expected": "Verwachting"
      },
      "totalAmount": "Totale inleg",
      "totalAmountOutgoing": "Totale uitgaande inleg",
      "totalAmountExpectedOutgoing": "Verwachte uitgaande inleg",
      "endedContracts": "Afgelopen contracten",
      "expectedEndedContracts": "Toekomstige afgelopen contracten"
    }
  },
  "partnerFee": {
    "field": {
      "partnerFeeAmount": "Huidige kosten",
      "expectedPartnerFeeAmount": "Verwachte kosten",
      "labels": {
        "amount": "Kosten",
        "expectedAmount": "Verwachte kosten"
      }
    }
  }
}


